import { render, staticRenderFns } from "./OccurrenceInfoBlock.vue?vue&type=template&id=26fcc274&scoped=true&"
import script from "./OccurrenceInfoBlock.vue?vue&type=script&lang=js&"
export * from "./OccurrenceInfoBlock.vue?vue&type=script&lang=js&"
import style0 from "./OccurrenceInfoBlock.vue?vue&type=style&index=0&id=26fcc274&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fcc274",
  null
  
)

export default component.exports